<template>
    <div>
      <v-card class="ma-2">
        <v-card-title test-tag="tag-248"><T>Фильтры</T></v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-menu
                v-model="startTimePicker"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field test-tag="tag-246"
                        :value="formattedDateStart"
                        label="Начало"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="mr-4"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateStartString"
                    :max="dateStartMax"
                    no-title
                    scrollable
                    locale="ru-RU"
                    :first-day-of-week="0"
                    @input="updateDateStart"
                ></v-date-picker>
            </v-menu>
            <v-btn test-tag="tag-245" class="mx-2" fab dark color="success" @click="updateData">
              <v-icon dark>mdi-autorenew</v-icon>
            </v-btn>
          </div>
          <div>
            <TextField
            dense
            class="mx-2 shrink"
            v-model="searchQuery"
            prepend-inner-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            style="height: 40px; width: 300px;"
            />
          </div>
        </v-card-text>
      </v-card>
  
      <v-card class="ma-2">
        <v-card-title test-tag="tag-249"><T>Картина дня</T></v-card-title>
        <v-card-text>
          <v-data-table test-tag="tag-247"
            :headers="headers"
            :items="filteredTableData"
            :loading="tableLoad"
            :loading-text="$t('Данные загружаются...')"
            :no-data-text="$t('Данные не найдены')"
            hide-default-footer
          >
            <template v-slot:item.guest="{ item }">
              <div>
                {{ item.name }}<br>
                {{ item.phone_number }}
              </div>
            </template>
          </v-data-table>
  
          <div class="mt-4">
            <div><strong>{{ $t('Итого заказов') }}:</strong> {{ totalOrders }}</div>
            <div><strong>{{ $t('Сумма заказов') }}:</strong> {{ totalSum }}</div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import TextField from '../../components/common/TextField.vue'
  export default {
    name: 'dayPictureReport',
  
    components: {
      TextField
    },
  
    data() {
      return {
        tableData: [],
        tableLoad: false,
        dateStart: new Date(),
        dateStartMax: null,
        dateEnd: new Date(),
        startTimePicker: false,
        searchQuery: '',
        search: '',
        headers: [
          { text: this.$t('№ Заказа'), value: 'id' },
          { text: this.$t('Гость (ФИО + Телефон)'), value: 'guest' },
          { text: this.$t('Тип заказа'), value: 'orderType' },
          { text: this.$t('Адрес'), value: 'address' },
          { text: this.$t('Зона доставки'), value: 'delivery_zone' },
          { text: this.$t('Сумма заказа'), value: 'rk_sum' },
          { text: this.$t('Статус'), value: 'status' },
          { text: this.$t('Принят'), value: 'accepted' },
          { text: this.$t('Завершен'), value: 'updated' },
          { text: this.$t('Длительность'), value: 'duration' },
          { text: this.$t('Оператор/Система'), value: 'operator' }
        ]
      };
    },
  
    computed: {
      formattedDateStart() {
          return this.dateStart.toLocaleDateString();
      },
      dateStartString: {
          get() {
              return this.dateStart.toISOString().substr(0, 10);
          },
          set(value) {
              this.dateStart = new Date(value);
          }
      },
      now() {
        return new Date().toISOString().split('T')[0];
      },
      formattedTableData() {
        return this.tableData.map(item => {
          const createdDate = new Date(item.created_at);
          const updatedDate = new Date(item.updated_at);
          const now = new Date();
          const deliveryZones = this.$store.getters.local_refs.geocoding.zones
          
          const formatTime = date => `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`;
  
          const statusMap = {
            DELAYED: this.$t('Отложенный'),
            NEW: this.$t('Новый'),
            COOKING: this.$t('Готовится'),
            DELIVERING: this.$t('Доставляется'),
            WAIT_PAY: this.$t('Оплатить'),
            ARCHIVED: this.$t('Завершен'),
            CANCELED: this.$t('Удален')
          };

          const getDuration = (startDate, endDate) => {
            const durationMs = endDate - startDate; // разница в миллисекундах
            const hours = Math.floor(durationMs / 3600000); // конвертируем в часы
            const minutes = Math.floor((durationMs % 3600000) / 60000); // оставшиеся минуты
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
          };
  
          return {
            ...item,
            orderType: item.order_type === 'DELIVERY' ? this.$t('Доставка') : this.$t('Самовывоз'),
            status: statusMap[item.status] || item.status,
            rk_sum: item.status === 'CANCELED' ? 0 : item.rk_sum,
            accepted: formatTime(createdDate),
            delivery_zone: deliveryZones[item.delivery_zone].name,
            updated: item.status === 'ARCHIVED' || item.status === 'CANCELED' ? formatTime(updatedDate) : 'NOW',
            duration: item.status === 'ARCHIVED' || item.status === 'CANCELED'
              ? getDuration(createdDate, updatedDate)
              : getDuration(createdDate, now)
          };
        });
      },

      filteredTableData() {
        const searchVal = this.searchQuery.toLowerCase();
        if (!searchVal) return this.formattedTableData;
        return this.formattedTableData.filter(item => {
          return (
            (item.name && item.name.toLowerCase().includes(searchVal)) ||
            (item.delivery_zone && item.delivery_zone.toLowerCase().includes(searchVal)) ||
            (item.address && item.address.toLowerCase().includes(searchVal)) ||
            (item.operator && item.operator.toLowerCase().includes(searchVal))
          );
        });
      },
      
      totalOrders() {
        return this.formattedTableData.length;
      },
      totalSum() {
        return this.formattedTableData.reduce((sum, item) => sum + Number(item.rk_sum), 0);
      }
    },
  
    mounted() {
      const maxDateStart = new Date(this.dateEnd);
      maxDateStart.setDate(maxDateStart.getDate());
      this.dateStartMax = maxDateStart.toISOString().substr(0, 10);
      this.updateData();
    },
  
    methods: {
      updateDateStart(date) {
        this.dateStart = new Date(date);
        if (this.dateStart >= this.dateEnd) {
            this.dateEnd = new Date();
        }
      },
      async updateData() {
        const date = this.dateStartString;
        this.tableLoad = true;
        this.tableData = await this.$store.dispatch('getDayPictureReportInfo', { date });
        this.tableLoad = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  .mt-4 {
    margin-top: 16px;
  }
  </style>